import {createApp, h} from 'vue';
import {InertiaProgress} from '@inertiajs/progress';
import {createInertiaApp} from '@inertiajs/inertia-vue3';
import {route} from 'ziggy-js';
import RoutePlugin from './plugin/route-plugin';
import TawkToPlugin from './plugin/tawkto';
import 'flowbite';
import 'flatpickr/dist/flatpickr.min.css';
import VueToastify from 'vue-toastify';
import 'vue-toastify/index.css';
import axios from 'axios';


InertiaProgress.init()

createInertiaApp({
    resolve: name => require(`./Pages/${name}`),
    title: title => title ? `${title} - Hvilya lake` : 'Hvilya lake',
    setup({el, App, props, plugin}) {
        const app = createApp({render: () => h(App, props)})
            .use(plugin)
            .use(RoutePlugin, {route})
            .use(VueToastify)
            .use(TawkToPlugin);
        app.config.globalProperties.$axios = axios
        app.mount(el)
    },
})
